import { LatLng } from "../maps/map-provider.interface";

/**
 * Coarse country centres, used only when the visitor has shared no location: to centre the map,
 * and to give HERE's autosuggest a search centre, which it rejects a request without.
 * Covers the countries Adora operates in — add a line when a new one is onboarded.
 */
const COUNTRY_CENTROIDS: Record<string, LatLng> = {
    BS: { lat: 25.0343, lng: -77.3963 },   // Nassau
    CA: { lat: 56.1304, lng: -106.3468 },  // centre of Canada
    ES: { lat: 40.4168, lng: -3.7038 },    // Madrid
    GB: { lat: 54.0000, lng: -2.0000 },    // centre of the United Kingdom
    MX: { lat: 19.4326, lng: -99.1332 },   // Mexico City
    PR: { lat: 18.2208, lng: -66.5901 },   // centre of Puerto Rico
    US: { lat: 39.8283, lng: -98.5795 }    // centre of the United States
};

const DEFAULT_COUNTRY_CODE = "US";

export function getCountryCentroid(countryCode?: string | null): LatLng {
    const normalized = countryCode?.trim().toUpperCase();

    return COUNTRY_CENTROIDS[normalized ?? ""] ?? COUNTRY_CENTROIDS[DEFAULT_COUNTRY_CODE];
}
